import React from 'react';
import DriModuleForm from '../../components/DriModuleForm';
import DriOperations from '../../actions/driOperations';

const DriInvoiceGeneration = () => {
  const processApiRequest = async (
    params,
    { setSuccessMessage, setErrorMessage, setSevereFailureErrorMessage },
  ) => {
    try {
      const response = await DriOperations.generateMultipleInvoices(params);

      if (response.ok) {
        const { successfulInvoiceStatements = [], failedInvoiceStatements = [] } =
          await response.json();

        if (successfulInvoiceStatements.length > 0) {
          const successMessages = successfulInvoiceStatements.map(
            statementSuccessLog =>
              `Contract Id: ${statementSuccessLog.contractId}\nStatement Id: ${
                statementSuccessLog.statementId
              }\nMessage: ${JSON.stringify(statementSuccessLog.message)}`,
          );
          setSuccessMessage(
            `Successfully queued generation of invoices for ${successMessages.length} statements`,
          );
          console.log({successMessages}) // eslint-disable-line
        }
        if (failedInvoiceStatements.length > 0) {
          const failedMessages = failedInvoiceStatements.map(
            statementErrorLog =>
              `Contract Id: ${statementErrorLog.contractId}\nStatement Id: ${statementErrorLog.statementId}\nError: ${statementErrorLog.error}`,
          );
          setErrorMessage(
            `Failed to queue generatation of invoices for ${failedMessages.length} statements`,
          );
          console.error({failedMessages}) // eslint-disable-line
        }
        if (successfulInvoiceStatements.length === 0 && failedInvoiceStatements.length === 0) {
          setSuccessMessage('No Invoices generated because no statements were found.');
        }
      } else if (response.error) {
        throw new Error(JSON.stringify(response.error));
      } else {
        throw new Error(`${response.status} ${response.statusText}`);
      }
    } catch (error) {
      setSevereFailureErrorMessage(`${error}`);
    }
  };

  return (
    <>
      <DriModuleForm
        subModuleHeader="Generate Invoice for a SELECT list of approved statements"
        buttonText="Generate Invoices"
        formId="generate-select-invoices"
        onSubmit={async (contractIds, callbacks) =>
          processApiRequest({ selectedContractIds: contractIds }, callbacks)
        }
        inputs={[
          {
            id: 'contractIds',
            label: 'Enter any contract Ids of approved statements for the invoices to generate',
            type: 'picker',
            config: { pickerSuggestionsProps: { noResultsFoundText: 'Duplicate ContractId' } },
          },
        ]}
      />
      <DriModuleForm
        subModuleHeader="Generate Invoices for ALL approved statements EXCEPT an ignored list"
        buttonText="Generate Invoices"
        formId="generate-except-invoices"
        onSubmit={async (contractIds, callbacks) =>
          processApiRequest({ ignoredContractIds: contractIds }, callbacks)
        }
        inputs={[
          {
            id: 'contractIds',
            label:
              'Enter any contract Ids of statements that you do NOT want invoices generated for',
            type: 'picker',
            config: { pickerSuggestionsProps: { noResultsFoundText: 'Duplicate ContractId' } },
          },
        ]}
      />
    </>
  );
};

export default DriInvoiceGeneration;
